function isIOS() {
    return !window.MSStream && /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export default isIOS;